import * as React from 'react'

import { ErrorState } from '@/components/states'
import { isChunkLoadError } from '@/lib/lazy-page'

/**
 * Erro ao carregar ou desenhar uma rota não derruba o Hub inteiro: a moldura
 * (sidebar, topbar, barra do celular) continua e só a área da página mostra o
 * erro. Mudar `resetKey` (o caminho da rota) limpa o erro — sem remontar a
 * página a cada navegação, como uma `key` faria.
 */
export class RouteBoundary extends React.Component<
  { children: React.ReactNode; resetKey: string },
  { error: unknown }
> {
  override state: { error: unknown } = { error: null }

  static getDerivedStateFromError(error: unknown) {
    return { error }
  }

  override componentDidUpdate(previous: { resetKey: string }) {
    if (previous.resetKey !== this.props.resetKey && this.state.error !== null) {
      this.setState({ error: null })
    }
  }

  override componentDidCatch(error: unknown) {
    console.error('Falha ao carregar a rota', error)
  }

  override render() {
    const { error } = this.state
    if (error === null) return this.props.children
    return isChunkLoadError(error) ? (
      <ErrorState
        title="O Hub foi atualizado"
        description="Esta tela mudou de versão enquanto você navegava. Recarregue para abrir a versão nova."
        onRetry={() => window.location.reload()}
      />
    ) : (
      <ErrorState
        description="Esta tela falhou ao abrir. Tente de novo; se persistir, avise o time de Sistemas."
        onRetry={() => this.setState({ error: null })}
      />
    )
  }
}
